import { useState, type FormEvent } from 'react';
import { parseYouTubeVideoId } from '../lib/youtube';
import './YouTubeRequest.css';

export default function YouTubeRequest({
  compact = false,
  onRequest,
  disabled,
}: {
  compact?: boolean;
  onRequest: (youtubeUrl: string) => Promise<void> | void;
  disabled?: boolean;
}) {
  const [url, setUrl] = useState('');
  const [busy, setBusy] = useState(false);
  const [localError, setLocalError] = useState<string | null>(null);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setLocalError(null);
    const trimmed = url.trim();
    if (!parseYouTubeVideoId(trimmed)) {
      setLocalError('Paste a valid YouTube watch, youtu.be, or Shorts URL.');
      return;
    }
    setBusy(true);
    try {
      await onRequest(trimmed);
      setUrl('');
    } catch (err) {
      setLocalError((err as Error).message);
    } finally {
      setBusy(false);
    }
  }

  const form = (
    <form className={`yt-request-form${compact ? ' compact' : ''}`} onSubmit={(e) => void submit(e)}>
      <input
        className="field search-field"
        type="text"
        inputMode="url"
        autoComplete="off"
        spellCheck={false}
        placeholder="Paste YouTube URL..."
        value={url}
        onChange={(e) => {
          setUrl(e.target.value);
          if (localError) setLocalError(null);
        }}
        disabled={disabled || busy}
        aria-label="YouTube URL"
      />
      <button className="btn btn-primary" type="submit" disabled={disabled || busy}>
        {busy ? 'Requesting…' : 'Request Video'}
      </button>
    </form>
  );

  if (compact) {
    return (
      <div className="search-wrap yt-request-wrap">
        {form}
        {localError && <div className="error-banner search-error">{localError}</div>}
      </div>
    );
  }

  return (
    <section className="yt-request panel fade-up">
      <h2 className="section-title">REQUEST FROM YOUTUBE</h2>
      <p className="muted yt-request-copy">
        <a
          href="https://www.youtube.com/@publicdomainmovies379"
          target="_blank"
          rel="noopener noreferrer"
        >
          Public Domain Movies
        </a>{' '}
        are 100% legal and free to watch. Browse that channel for more titles, then paste a YouTube
        URL here if the movie you want is not in the shelf below.
      </p>
      {form}
      {localError && <div className="error-banner" style={{ marginTop: '0.75rem' }}>{localError}</div>}
    </section>
  );
}
